import styled from "styled-components"
import {
  SpinnerLoader as BaseSpinnerLoader,
  type SpinnerLoaderProps,
} from "~/ur-react-components"

const StyledSpinnerLoader = styled(BaseSpinnerLoader)``

export const SpinnerLoader: React.CFC<SpinnerLoaderProps> = ({ ...props }) => {
  return <StyledSpinnerLoader {...props} />
}
